function changeCollectionGwpSection() {
  const collectionTotalAmountEl = document.querySelector('.js-totalAmount');
  const collectionRemainingAmountEl = document.querySelector('.js-remainingAmountEl');
  const noveltyInfoForMember = JSON.parse(document.getElementById("novelty-information-member").textContent);
  const GWPEvent = noveltyInfoForMember.events.find(event => event.criteria[0].spending > 1);
  
  // MutationObserverの設定
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-total') {
        // data-cart-total属性の変更を検知
        if(GWPEvent) {
          const spendingValue = parseInt(GWPEvent.criteria[0].spending) * 100;
          const newValue = parseInt(collectionTotalAmountEl.dataset.cartTotal);
          const remainingAmount = (parseInt(spendingValue - newValue) / 100).toLocaleString();
    
          if(spendingValue > newValue) {
            collectionRemainingAmountEl.innerHTML = `あと${remainingAmount}円の購入で、<br >ギフトがつきます`;
          } else {
            if (window.customer) {
              collectionRemainingAmountEl.innerHTML = `ギフトを贈呈いたしました`;
            } else {
              collectionRemainingAmountEl.innerHTML = `ログインすると<br>ギフトを贈呈いたします`;
            }
          }
        }
      }
    }
  });
  
  // 監視対象の要素とオプションを指定
  observer.observe(collectionTotalAmountEl, {
    attributes: true,
    attributeFilter: ['data-cart-total']
  });
}

window.addEventListener('DOMContentLoaded', changeCollectionGwpSection);
